import React from 'react';

const Header = () => {
    return (
        <div className="header">
            Meme cased.
        </div>
    )
}

export default Header;